import { organizationConstants } from '../constants/organizationConstants';

const initialState = {
    fetchingOrganization: false,
    organization: null,
    updatingOrganization: false,
    fetchingOrganizationError: null,
    updatingOrganizationError: null,

    updatingBaseCurrency: false,
    updatingBaseCurrencyError: null,

    pollingExpandedPeriods: false,
};

export function organization(state = initialState, action) {
    switch (action.type) {
        case organizationConstants.GET_ORGANIZATION_REQUEST: {
            return {
                ...state,
                fetchingOrganization: true,
                fetchingOrganizationError: null,
            };
        }
        case organizationConstants.GET_ORGANIZATION_SUCCESS: {
            return {
                ...state,
                fetchingOrganization: false,
                organization: action.organization,
                fetchingOrganizationError: null,
            };
        }
        case organizationConstants.GET_ORGANIZATION_FAILURE: {
            return {
                ...state,
                fetchingOrganization: false,
                fetchingOrganizationError: action.error,
            };
        }

        case organizationConstants.UPDATE_ORGANIZATION_REQUEST: {
            return {
                ...state,
                updatingOrganization: true,
                updatingOrganizationError: null,
            };
        }
        case organizationConstants.UPDATE_ORGANIZATION_SUCCESS: {
            return {
                ...state,
                updatingOrganization: false,
                organization: action.updatedOrganization,
            };
        }
        case organizationConstants.UPDATE_ORGANIZATION_FAILURE: {
            return {
                ...state,
                updatingOrganization: false,
                updatingOrganizationError: action.error,
            };
        }

        case organizationConstants.UPDATE_BASE_CURRENCY_REQUEST: {
            return {
                ...state,
                updatingBaseCurrency: true,
                updatingBaseCurrencyError: null,
            };
        }
        case organizationConstants.UPDATE_BASE_CURRENCY_SUCCESS: {
            return {
                ...state,
                updatingBaseCurrency: false,
                organization: action.organization,
                updatingBaseCurrencyError: null,
            };
        }
        case organizationConstants.UPDATE_BASE_CURRENCY_FAILURE: {
            return {
                ...state,
                updatingBaseCurrency: false,
                updatingBaseCurrencyError: action.error,
            };
        }
        
        case 'EXPANDED_PERIODS_POLLING_START': {
            return {
                ...state,
                pollingExpandedPeriods: true,
            };
        }
        
        case 'EXPANDED_PERIODS_POLLING_SUCCESS':
        case 'EXPANDED_PERIODS_POLLING_TIMEOUT':
        case 'EXPANDED_PERIODS_POLLING_ERROR': {
            return {
                ...state,
                pollingExpandedPeriods: false,
            };
        }
        default: {
            return state;
        }
    }
}
